import { StatusAnnouncer as StatusAnnouncer$1 } from "../../../../../ui/status-announcer/component.js";
import { jsx } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/feedback/status-announcer.tsx
/** @jsxImportSource react */
function StatusAnnouncer({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(StatusAnnouncer$1, {
		className: (state) => cn("media-status-announcer", resolveClassName(className, state)),
		...props
	});
}
//#endregion
export { StatusAnnouncer };

//# sourceMappingURL=status-announcer.js.map